import React, { useEffect } from "react";
import SplashPage from "./SplashPage";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "../context/AuthContext";

const LoggedPage = () => {

    const navigate = useNavigate();
    const {  authenticated, user } = useAuthState();

    useEffect(() => {
        if (authenticated) {
            if (user.x_is_house_management)
                navigate('/hw/dashboard/');
            else
                navigate('/dashboard/');
        } 
    }, [authenticated])

    return (
        <SplashPage />
    )
}

export default LoggedPage;